import * as Actions from '../actions'

const initialState = {
  isOpen: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case Actions.IS_OPEN_FEATURE_HIGHLIGHT: {
      return { isOpen: action.payload }
    }
    default: {
      return state
    }
  }
}
